import { observable } from "mobx";
import { Type } from "class-transformer";
import DomesticBankAccountResponse from "./domesticBankAccountResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerRefundCandidatePayGatePaymentResponse {
  @observable
  merchantId!: string;

  @observable
  terminalId!: string;

  @observable
  @Type(() => Date)
  authorizedAt!: Date;

  @observable
  invoiceNumber!: string;

  @observable
  paidAmount!: number;

  @observable
  authCode!: string;

  @observable
  cardNumber!: string;

  @observable
  arn!: string;

  @observable
  variableSymbol?: number;

  @observable
  @Type(() => DomesticBankAccountResponse)
  merchantBankAccount!: DomesticBankAccountResponse;
}
